var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4475 1.0009L6.80055 1.0009C5.39158 0.975881 4.02252 1.47123 2.95323 2.39292C1.88395 3.31462 1.1889 4.59849 1.00001 6.00081V23.5005C1.1889 24.9028 1.88395 26.1867 2.95323 27.1084C4.02252 28.0301 5.39158 28.5254 6.80055 28.5004H13.4475M30.874 33.5003V43.5001C30.874 45.4892 30.0872 47.3968 28.6866 48.8033C27.2859 50.2098 25.3863 51 23.4055 51L13.4475 28.5004V1.0009L41.5291 1.0009C42.7299 0.987272 43.8951 1.40988 44.81 2.19087C45.725 2.97185 46.3281 4.05858 46.5081 5.25083L49.9436 27.7504C50.0519 28.467 50.0038 29.1987 49.8026 29.8948C49.6013 30.5908 49.2518 31.2346 48.7782 31.7816C48.3046 32.3285 47.7182 32.7655 47.0597 33.0623C46.4012 33.3591 45.6863 33.5085 44.9646 33.5003H30.874Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsIcon);
export default __webpack_public_path__ + "static/media/thumbs-icon.6a0e652d3306f79670866a820b27e87e.svg";
export { ForwardRef as ReactComponent };